import { Label } from '@components/label/src/label';
import classNames from 'classnames';

import { LabelPrimaryProps } from './label.types';

export const LabelPrimary = ({
  children,
  hasError = false,
  description,
  className,
  useDefaultTextClassName,
  isBold,
  isHeadline,
  customColors,
  marginBottomClassName = 'mb-2',
  ...props
}: LabelPrimaryProps) => {
  return (
    <div className={classNames(className, 'flex flex-row items-center', marginBottomClassName)}>
      <Label
        className={classNames(
          {
            'text-critical': hasError,
            'text-primary': !hasError && !customColors,
            'text-body-xs': !isBold,
            'text-subtitle-xs': isBold && !isHeadline,
            'text-headline-xs': isBold && isHeadline,
          },
          !hasError && customColors ? customColors : undefined
        )}
        {...props}>
        {children}
      </Label>
      {description && <span className='ml-2 text-primary text-body-xs'>{description}</span>}
    </div>
  );
};
